import { useEffect } from 'react'
import { useSwiper } from 'swiper/react'
import type { MealPeriod } from '~/lib/graphql/graphql'
import type { HourMinute } from '~/lib/graphql/scalars'

type TimesPositionInput =
  | {
      type: 'planConfirmed'
      mealPeriod: MealPeriod
      slideIndex: number
      visitTime: HourMinute
    }
  | {
      type: 'planUnconfirmed'
      slideIndex: number
      selectedVisitTime?: HourMinute
      visitTime: HourMinute
    }

/**
 * 時間つぶのデフォルト位置を設定するカスタムフック
 * 親コンポーネントで SwiperSlide と Swiper が使用されている前提
 */
export function useInitialTimesPosition(input: TimesPositionInput) {
  const swiper = useSwiper()
  // slideIndexをそのまま使用すると、画面の一番左に時間つぶが位置してしまうため、-1する
  useEffect(() => {
    if (input.type === 'planConfirmed') {
      // ランチは12：00、ディナーは19：00、朝食とティーは特に設定しない
      // @see:https://github.com/ikyucom/macaron-frontend/issues/286
      switch (input.mealPeriod) {
        case 'LUNCH':
          input.visitTime === '12:00' && swiper.slideTo(input.slideIndex - 1, 1)
        case 'DINNER':
          input.visitTime === '19:00' && swiper.slideTo(input.slideIndex - 1, 1)
      }
    }
    if (input.type === 'planUnconfirmed') {
      input.selectedVisitTime === input.visitTime && swiper.slideTo(input.slideIndex - 1, 1)
    }
  }, [input, swiper])
}
